module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA6klEQVQ4T+3SsUrDUBTG8f+5COJQAi4Bd8FVM4iv4CM49iWKpYkhWfoSjr6HL3AjjoKzW6Gd6qA5UmhCIvVyk8atdz7nd8/57hUGPjKwxz+CqZqo5AMIe02t3Ntc5vWEUaIL4LQXtm2ymUgT1H2wTW8X8FthLsolwu1fF/uCbzaTiwqJJhpwzHIX6gWODCfPqXw2gSjRnfF4gWo4L1J5HwwE1GZi6pVjvUN46r1yl5f3WvkAOhPomuEKCFyiL5jYTPIKup5q+HVEAZz9xttgrDOEqnFdKjcvuby6Jrp60EdRxlVNC+zyPVy1P2mbbBUkVS5BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/about-c_icon_cp_sel.png
// module id = wCZB
// module chunks = 1